/**
 * SC21 Native Filter Engine - v0.9.0 (Full Shopify Multilingual Support)
 */
class SC21VehicleFilter {
  constructor() {
    this.container = document.querySelector('.sc21-filter-section');
    if (!this.container) return;
    
    window.sc21VehicleFilter = this; 

    // Rilevamento Lingua e Rotta da Shopify Liquid
    const rawLocale = this.container.getAttribute('data-locale') || 'it';
    this.currentLocale = rawLocale.toLowerCase();
    
    let root = this.container.getAttribute('data-root-url') || '/';
    if (!root.endsWith('/')) root += '/';
    this.rootUrl = root;
    this.currencyCode = this.container.getAttribute('data-currency') || (window.Shopify && Shopify.currency && Shopify.currency.active) || 'EUR';
    this.numberLocale = document.documentElement.lang || this.currentLocale;

    // Traduzioni UI della sezione
    const i18nRaw = this.container.getAttribute('data-i18n');
    try {
      this.i18n = JSON.parse(i18nRaw);
    } catch (e) {
      this.i18n = {
        selectMarca: "Seleziona Marca",
        selectModello: "Seleziona Modello",
        selectMarcaFirst: "Seleziona prima una marca",
        selectTipo: "Tutti i tipi",
        noProducts: "Nessun prodotto trovato per questa selezione.",
        viewProduct: "Visualizza Prodotto",
        notSpecified: "Non specificato",
        loading: "Caricamento..."
      };
    }

    this.indexUrl = this.container.getAttribute('data-index-url');
    this.collectionProductsUrl = this.container.getAttribute('data-collection-products-url');
    this.marketProducts = new Map();
    this.selectMarca = document.getElementById('sc21-select-marca');
    this.selectModello = document.getElementById('sc21-select-modello');
    this.selectTipo = document.getElementById('sc21-select-tipo');
    this.btnReset = document.getElementById('sc21-reset');
    this.grid = document.getElementById('sc21-products-grid');
    this.loader = document.getElementById('sc21-products-loader');
    this.paginationList = document.getElementById('sc21-pagination-list');
    this.paginationContainer = document.getElementById('sc21-pagination-container');

    this.indexData = null;
    this.filteredProducts = [];
    this.currentPage = 1;
    this.productsPerPage = 20;

    this.init();
  }

  // Funzione helper per estrarre il testo nella lingua corretta con fallback
  getText(val) {
    if (!val) return '';
    if (typeof val === 'string') return val;
    return val[this.currentLocale] || val['it'] || val['en'] || '';
  }

  async init() {
    if (!this.indexUrl) {
      this.abortLoad(this.i18n.loading);
      return;
    }
    this.bindEvents();
    await this.loadIndex();
  }

  bindEvents() {
    // Cambio MARCA -> Reset Modello e Tipo
    if (this.selectMarca) {
      this.selectMarca.addEventListener('change', () => {
        if (this.selectModello) this.selectModello.value = '';
        if (this.selectTipo) this.selectTipo.value = '';
        this.currentPage = 1;
        this.processFilters();
      });
    }

    // Cambio MODELLO -> Reset Tipo
    if (this.selectModello) {
      this.selectModello.addEventListener('change', () => {
        if (this.selectTipo) this.selectTipo.value = '';
        this.currentPage = 1;
        this.processFilters();
      });
    }

    // Cambio TIPO
    if (this.selectTipo) {
      this.selectTipo.addEventListener('change', () => {
        this.currentPage = 1;
        this.processFilters();
      });
    }

    if (this.btnReset) {
      this.btnReset.addEventListener('click', () => this.resetFilters());
    }
  }

  async loadIndex() {
    try {
      const response = await fetch(this.indexUrl);
      if (!response.ok) {
        throw new Error(`Risposta server KO: ${response.status} ${response.statusText}`);
      }
      
      this.indexData = await response.json();
      
      if (!this.indexData || !Array.isArray(this.indexData.products)) {
        throw new Error("L'indice JSON non contiene un array 'products' valido.");
      }

      this.marketProducts = await this.loadMarketProducts();
      this.indexData.products = this.indexData.products.filter((product) => {
        return product && product.handle && this.marketProducts.has(product.handle);
      });

      this.filteredProducts = this.indexData.products;
      this.buildDropdownOptions(this.indexData.products, true);
      this.renderCurrentPage();
    } catch (error) { 
      console.error('[SC21] Errore critico durante il caricamento dell\'indice:', error); 
      this.abortLoad(this.i18n.loading);
    }
  }

  async loadMarketProducts() {
    if (!this.collectionProductsUrl) {
      throw new Error("URL della collezione non disponibile.");
    }

    const productsByHandle = new Map();
    let page = 1;

    while (true) {
      const separator = this.collectionProductsUrl.includes('?') ? '&' : '?';
      const response = await fetch(`${this.collectionProductsUrl}${separator}limit=250&page=${page}`, {
        headers: { Accept: 'application/json' }
      });

      if (!response.ok) {
        throw new Error(`Impossibile caricare i prodotti del mercato: ${response.status}`);
      }

      const payload = await response.json();
      const products = Array.isArray(payload.products) ? payload.products : [];

      products.forEach((product) => {
        if (product && product.handle) productsByHandle.set(product.handle, product);
      });

      if (products.length < 250) break;
      page += 1;

      if (page > 100) {
        throw new Error("Limite di paginazione prodotti superato.");
      }
    }

    return productsByHandle;
  }

  buildDropdownOptions(productsScope, isInitial = false) {
    if (!productsScope || !Array.isArray(productsScope)) return;

    const currentMarca = this.selectMarca ? this.selectMarca.value : '';
    const currentModello = this.selectModello ? this.selectModello.value : '';
    const currentTipo = this.selectTipo ? this.selectTipo.value : '';

    const marcheSet = new Set();
    const modelliSet = new Set();
    const tipiSet = new Set();

    productsScope.forEach(p => {
      if (!p) return;
      
      const typeStr = this.getText(p.type);
      if (typeStr) tipiSet.add(typeStr);

      if (p.vehicles && Array.isArray(p.vehicles)) {
        p.vehicles.forEach(v => {
          if (!v) return;
          const brandStr = this.getText(v.brand);
          const modelStr = this.getText(v.model);

          if (brandStr) marcheSet.add(brandStr);
          if (modelStr && currentMarca && brandStr === currentMarca) {
            modelliSet.add(modelStr);
          }
        });
      }
    });

    if (this.selectMarca && (isInitial || !currentMarca)) {
      this.renderSelectOptions(this.selectMarca, marcheSet, currentMarca, this.i18n.selectMarca);
    }

    if (this.selectModello) {
      this.renderSelectOptions(
        this.selectModello, 
        modelliSet, 
        currentModello, 
        currentMarca ? this.i18n.selectModello : this.i18n.selectMarcaFirst
      );
      this.selectModello.disabled = !currentMarca || modelliSet.size === 0;
    }

    if (this.selectTipo) {
      this.renderSelectOptions(this.selectTipo, tipiSet, currentTipo, this.i18n.selectTipo);
      this.selectTipo.disabled = tipiSet.size === 0;
    }
  }

  renderSelectOptions(el, set, val, placeholder) {
    if (!el) return;
    el.innerHTML = `<option value="">${placeholder}</option>`;
    Array.from(set).sort().forEach(item => {
      const opt = document.createElement('option');
      opt.value = item; opt.textContent = item;
      if (item === val) opt.selected = true;
      el.appendChild(opt);
    });
  }

  processFilters() {
    if (!this.indexData || !Array.isArray(this.indexData.products)) return;
    
    let ds = this.indexData.products;
    const m = this.selectMarca ? this.selectMarca.value : '';
    const md = this.selectModello ? this.selectModello.value : '';
    const t = this.selectTipo ? this.selectTipo.value : '';
    
    if (m) ds = ds.filter(p => p.vehicles && p.vehicles.some(v => this.getText(v.brand) === m));
    if (md) ds = ds.filter(p => p.vehicles && p.vehicles.some(v => this.getText(v.model) === md));
    if (t) ds = ds.filter(p => this.getText(p.type) === t);
    
    this.filteredProducts = ds;
    this.buildDropdownOptions(ds);
    this.renderCurrentPage();
  }

  async renderCurrentPage() {
    if (!this.grid) return;
    this.grid.innerHTML = '';
    
    const slice = this.filteredProducts.slice((this.currentPage - 1) * this.productsPerPage, this.currentPage * this.productsPerPage);
    
    if (slice.length === 0) {
      this.grid.innerHTML = `<p style="width:100%; text-align:center; padding: 2rem;">${this.i18n.noProducts}</p>`;
      if (this.paginationContainer) this.paginationContainer.classList.add('hidden');
      return;
    }

    this.toggleLoader(true);
    const validProducts = slice.filter(p => p && p.handle);

    // Fetch dinamico basato sulla rotta della lingua corrente (es. /en/products/handle.js)
    const products = (await Promise.all(validProducts.map(async (p) => {
      try {
        const r = await fetch(`${this.rootUrl}products/${p.handle}.js`);
        if (!r.ok) throw new Error("404");
        const shopifyData = await r.json();
        return {
          ...shopifyData,
          availability: p.availability,
          supplierSku: p.supplierSku || ''
        };
      } catch (e) {
        return null;
      }
    }))).filter(Boolean);
    
    this.toggleLoader(false);

    this.grid.innerHTML = products.map(p => {
      if (!p) return '';
      const firstImg = p.featured_image || '';
      const secondImg = p.images && p.images.length > 1 ? p.images[1] : firstImg;
      const hasSecondary = p.images && p.images.length > 1 ? 'media--hover-effect' : '';
      const formattedAmount = new Intl.NumberFormat(this.numberLocale, { style: 'currency', currency: this.currencyCode }).format(p.price / 100);
      const fromLabel = this.currentLocale === 'it' ? 'Da ' : 'From ';
      const formattedPrice = p.price > 0 ? `${fromLabel}${formattedAmount} ${this.currencyCode}` : this.i18n.viewProduct;

      let dotClass = 'sc21-dot-gray';
      const avail = (p.availability || '').toLowerCase();
      
      if (avail.includes('in stock') || avail.includes('in_stock')) {
        dotClass = 'sc21-dot-green';
      } else if (avail.includes('available on order') || avail.includes('available_on_order')) {
        dotClass = 'sc21-dot-yellow';
      } else if (avail.includes('made to order') || avail.includes('made_to_order')) {
        dotClass = 'sc21-dot-blue';
      }

      return `
        <li class="sc21-product-item">
          <div class="card-wrapper product-card-wrapper underline-links-hover">
            <div class="card card--standard card--media">
              <div class="card__inner rgb(var(--color-background)) face-card-radius ratio" style="width: 100%; --ratio-percent: 100%; position: relative;">
                <div class="card__media" style="width: 100%;">
                  <div class="media media--transparent ${hasSecondary}" style="position: relative; padding-bottom: 100%; display: block;">
                    <img src="${firstImg}" class="motion-reduce" loading="lazy" width="300" height="300" style="object-fit: cover; position: absolute; top:0; left:0; width:100%; height:100%;">
                    ${p.images && p.images.length > 1 ? `<img src="${secondImg}" class="small-hide medium-hide large-up-show" loading="lazy" width="300" height="300" style="object-fit: cover; position: absolute; top:0; left:0; width:100%; height:100%;">` : ''}
                  </div>
                </div>
              </div>
              <div class="card__content">
                <div class="card__information">
                  <span class="sc21-vendor-text light">${p.vendor || ''}${p.supplierSku ? ` · ${p.supplierSku}` : ''}</span>
                  <div class="sc21-card-title-container">
                    <h3 class="card__heading h5">
                      <a href="${p.url}" class="full-unstyled-link">${p.title}</a>
                    </h3>
                    <span class="sc21-filter-dot ${dotClass}" title="${p.availability || this.i18n.notSpecified}"></span>
                  </div>
                  <div class="price">
                    <div class="price__container">
                      <span class="price-item price-item--regular" style="font-weight: bold; font-size: 1.5rem;">
                        ${formattedPrice}
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </li>
      `;
    }).join('');

    this.renderPaginationUI();
  }
  
  renderPaginationUI() {
    if (!this.paginationList || !this.paginationContainer) return;
    this.paginationList.innerHTML = '';
    const pages = Math.ceil(this.filteredProducts.length / this.productsPerPage);
    
    if (pages <= 1) {
      this.paginationContainer.classList.add('hidden');
      return;
    }

    this.paginationContainer.classList.remove('hidden');

    for (let i = 1; i <= pages; i++) {
      const li = document.createElement('li');
      const btn = document.createElement('button');
      btn.textContent = i;
      btn.className = (i === this.currentPage) ? 'pagination__item pagination__item--current button' : 'pagination__item link button button--secondary';
      btn.style.minWidth = '4rem';
      btn.style.height = '4rem';
      btn.style.padding = '0';
      btn.onclick = () => { 
        this.currentPage = i; 
        this.renderCurrentPage(); 
        window.scrollTo({ top: this.container.offsetTop - 50, behavior: 'smooth' });
      };
      li.appendChild(btn);
      this.paginationList.appendChild(li);
    }
  }

  resetFilters() {
    if (!this.indexData) return;
    if (this.selectMarca) this.selectMarca.value = ''; 
    if (this.selectModello) this.selectModello.value = ''; 
    if (this.selectTipo) this.selectTipo.value = '';
    this.currentPage = 1;
    this.filteredProducts = this.indexData.products;
    this.buildDropdownOptions(this.indexData.products, true);
    this.renderCurrentPage();
  }

  abortLoad(placeholderMessage) {
    if (this.selectMarca) {
      this.selectMarca.innerHTML = `<option value="">${placeholderMessage}</option>`;
    }
    this.toggleLoader(false);
  }

  toggleLoader(s) { if (this.loader) this.loader.classList.toggle('hidden', !s); }
}

document.addEventListener('DOMContentLoaded', () => new SC21VehicleFilter());
